import { ref } from 'vue'

export function useClubRegisterLastStep() {
  const stepLoading = ref(false)
  const stepSaving = ref(false)

  async function saveLastStep(clubId, step) {
    stepSaving.value = true
    try {
      await localStorage.setItem(`clubRegLastStep-${clubId}`, step)
    } catch (e) {
      console.log(e)
    } finally {
      stepSaving.value = false
    }
  }

  async function getLastStep(clubId) {
    stepLoading.value = true
    try {
      return await localStorage.getItem(`clubRegLastStep-${clubId}`)
    } catch (e) {
      console.log(e)
    } finally {
      stepLoading.value = false
    }
  }

  async function removeLastStep(clubId) {
    stepSaving.value = true
    try {
      await localStorage.removeItem(`clubRegLastStep-${clubId}`)
    } catch (e) {
      console.log(e)
    } finally {
      stepSaving.value = false
    }
  }

  return { saveLastStep, getLastStep, removeLastStep }
}
